import { Box, Form, Section } from '@factorialco/deprecated-design-system'

import { PanesPad } from 'modules/core/components/PanesPad'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import type AccessGroup from 'modules/core/store/models/AccessGroup'

import GroupForm from 'modules/surveys/components/Participants/GroupForm'
import type { Participant } from 'modules/surveys/lib/participant'
import type SurveyForm from 'modules/surveys/store/models/Form'
import type Survey from 'modules/surveys/store/models/v2/Survey'

import AccessGroupTable from './AccessGroupTable'

interface ParticpantsMembersSectionProps {
  accessGroup: AccessGroup
  surveyId: string
  allowAddParticipants: boolean
  participants: Participant[]
}

export function ParticipantsMembersSection({
  accessGroup,
  surveyId,
  allowAddParticipants,
  participants,
}: ParticpantsMembersSectionProps) {
  const { navigation } = useNavigation()

  return (
    <Section.FullWidth
      illustration="surveys"
      title={i18n.t('surveys.form.participants.title')}
      description={i18n.t('surveys.form.participants.description')}
      action={
        allowAddParticipants
          ? {
              to: navigation.engagement.surveys.id.participants.new.fullPath({ id: surveyId }),
              label: i18n.t('surveys.form.participants.new.title'),
            }
          : undefined
      }
    >
      <Box>
        <AccessGroupTable
          accessGroup={accessGroup}
          surveyId={surveyId}
          participants={participants}
        />
      </Box>
    </Section.FullWidth>
  )
}

interface ParticpantsDynamicSectionProps {
  accessGroup: AccessGroup
  form: SurveyForm | Survey
  onSubmit: () => void
  allowAddParticipants: boolean
  canEditSurvey: boolean
  participants: Participant[]
}

export function ParticipantsDynamicSection({
  accessGroup,
  onSubmit,
  form,
  allowAddParticipants,
  canEditSurvey,
  participants,
}: ParticpantsDynamicSectionProps) {
  const { navigation } = useNavigation()

  return (
    <>
      <Section
        illustration="surveys"
        title={i18n.t('surveys.form.participants.title')}
        description={i18n.t('surveys.form.participants.description')}
        action={
          allowAddParticipants
            ? {
                to: navigation.engagement.surveys.id.participants.new.fullPath({
                  id: form.attributes.id,
                }),
                label: i18n.t('surveys.form.participants.new.title'),
              }
            : undefined
        }
      >
        <Form withBackground>
          <GroupForm
            accessGroup={accessGroup}
            onSubmit={onSubmit}
            survey={form}
            canEditSurvey={canEditSurvey}
          />
        </Form>
      </Section>
      <PanesPad>
        <Box>
          <AccessGroupTable
            accessGroup={accessGroup}
            surveyId={form.attributes.id}
            participants={participants}
          />
        </Box>
      </PanesPad>
    </>
  )
}
